import { useMutation } from '@tanstack/react-query';

import type {
  FormPayloadSchema,
  FinanceValidationError,
} from '../schema/carFinance.schema';
import { carFinanceApi } from '../../../../api/carFinanceApi';
import { handleFinanceValidationError } from './handleFinanceValidationError';
import { PAGE } from '../../../../helpers/pages';

type ValidateStepParams = {
  step: number;
  payload: FormPayloadSchema;
};

type UseValidateStepProps = {
  onValidationError: (errors: FinanceValidationError) => void;
  onSuccess: () => void;
};

const validateFinanceStep = async (
  step: number,
  payload: FormPayloadSchema,
) => {
  const { data } = await carFinanceApi.validateStep(step, payload);
  return data;
};

export const useValidateStep = (props: UseValidateStepProps) => {
  const { onValidationError, onSuccess } = props;
  return useMutation({
    mutationKey: ['validateFinanceStep'],
    mutationFn: ({ step, payload }: ValidateStepParams) =>
      validateFinanceStep(step, payload),
    onError: (error) =>
      handleFinanceValidationError(
        error,
        onValidationError,
        'Car finance step validation error field mismatch',
      ),
    onSuccess,
    meta: { tags: [PAGE.CAR_FINANCE] },
  });
};
